// extracted by mini-css-extract-plugin
export default {"yesterday":"index_yesterday_DyFtJ"};